/**
 * @generated SignedSource<<acad1d13d197ae0ca2d202857114050d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCheckout_checkout$data = {
  readonly active: boolean | null | undefined;
  readonly company: {
    readonly projectType: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutCompanyData_company" | "PaymentCompanyLogo_company" | "PaymentCompanySupport_company">;
  } | null | undefined;
  readonly id: string;
  readonly type: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckoutDeactivated_checkout" | "PaymentCheckoutHeading_checkout" | "PaymentCheckoutMethods_checkout" | "PaymentCheckoutPixAutomatic_checkout" | "PaymentCheckoutTitle_checkout">;
  readonly " $fragmentType": "PaymentCheckout_checkout";
};
export type PaymentCheckout_checkout$key = {
  readonly " $data"?: PaymentCheckout_checkout$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCheckout_checkout">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCheckout_checkout",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "active",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectType",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanyLogo_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCheckoutCompanyData_company"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PaymentCompanySupport_company"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutHeading_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutTitle_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutMethods_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutDeactivated_checkout"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCheckoutPixAutomatic_checkout"
    }
  ],
  "type": "Checkout",
  "abstractKey": null
};

(node as any).hash = "f0c814efced1df702a7140be4088ded3";

export default node;
